module.exports = __webpack_public_path__ + "img/算.d0f091a3.png";